require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-our-grange-residence-featured-in-architecture-and-design.json") })
        }
      }, "path---journal-our-grange-residence-featured-in-architecture-and-design");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-our-grange-residence-featured-in-architecture-and-design!./.cache/json/journal-our-grange-residence-featured-in-architecture-and-design.json
// module id = 519
// module chunks = 231608221292675